// extracted by mini-css-extract-plugin
export default {"root":"EventCardBookmarksCount-module__root___39eu2"};